/*跨域地址*/
const dev = process.env.dev

export default {
  /**提交问卷答案 */
  submitAnswers2: {
    url: dev + '/sv/order/extra/info',
    method: 'post'
  },
  /** 获取用户信息*/
  getQuestionnaireUserInfo2: {
    url: dev + '/sv/order/cust/gender',
    method: 'get'
  },
  /**获取问卷答案 */
  getQuestionnaireAnswer2: {
    url: dev + '/sv/order/extra/info',
    method: 'get'
  }
};



// WEBPACK FOOTER //
// ./src/api/questionnaire2.js